export const MUTATE_AUTH_IS_LOGIN = 'MUTATE_AUTH_IS_LOGIN';
export const MUTATE_AUTH_NAME = 'MUTATE_AUTH_NAME';
export const MUTATE_AUTH_EMAIL = 'MUTATE_AUTH_EMAIL';
export const MUTATE_AUTH_TOKEN = 'MUTATE_AUTH_TOKEN';

interface IAuth {
  isLogin: boolean;
  name: string;
  email: string;
  token: string;
}

// inital state
const Auth: IAuth = {
  isLogin: false,
  name: '',
  email: '',
  token: ''
};

// getters
const getters = {
  isLogin: ( state: IAuth ) => state.isLogin,
  getName: ( state: IAuth ) => state.name,
  getEmail: ( state: IAuth ) => state.email,
  getToken: ( state: IAuth ) => state.token
};
// mutations
const mutations = {
  [MUTATE_AUTH_IS_LOGIN](state: IAuth, payload: boolean) {
    state.isLogin = payload;
  },
  [MUTATE_AUTH_NAME](state: IAuth, payload: string) {
    state.name = payload;
  },
  [MUTATE_AUTH_EMAIL](state: IAuth, payload: string) {
    state.email = payload;
  },
  [MUTATE_AUTH_TOKEN](state: IAuth, payload: string) {
    state.token = payload;
  },
};

// actions
const actions = {
};

export default {
  state: Auth,
  getters,
  actions,
  mutations,
};
